// removed by extract-text-webpack-plugin
module.exports = {"section":"src-pages----blog-module---section---2nBU7","content":"src-pages----blog-module---content---3JkS-","smallCaps":"src-pages----blog-module---smallCaps---3GmyQ","pointers":"src-pages----blog-module---pointers---37NXg","icon":"src-pages----blog-module---icon---1y2Zs","fill":"src-pages----blog-module---fill---36P1k"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/blog.module.scss
// module id = 566
// module chunks = 212839066777427